export default __webpack_public_path__ + "static/media/arabia-developments-mini-logo.4e2d7472.svg";